import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "widget-tab-inner h-100 filler text-" }

import {computed, ref, watch} from 'vue';
import SideMenu from "~/chat/vue/widget/sideMenu/SideMenu.vue";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {TAB_TYPE_CHAT} from "~/chat/ts/data/ITab";
import ChatTab from "~/chat/vue/widget/tabs/ChatTab.vue";
import ContentTab from "~/chat/vue/widget/tabs/ContentTab.vue";
import {CHAT_EVENT_MOUSE_MOVE_ON_WIDGET_INNER_ROOT} from "~/chat/ts/Constants";
import ReviewForm from "~/chat/vue/widget/tabs/reviews/ReviewForm.vue";
import ExportChatForm from "~/chat/vue/widget/tabs/chat/ExportChatForm.vue";
import ChatRootModalMessage from "~/chat/vue/widget/ChatRootModalMessage.vue";
import {ChatEventManagerInstance} from "~/chat/ts/ChatEventManager";
import ClientCaptcha from "~/chat/vue/widget/ClientCaptcha.vue";
import Delay from "~/ts/library/Delay";
import WidgetWebRtcCallOverlay from "~/chat/vue/widget/webRtc/WidgetWebRtcCallOverlay.vue";
import {ConfigStore} from "~/chat/ts/store/Config";


const __default__ = {
    name: "WidgetInnerRoot"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function onMouseMove() {
    ChatEventManagerInstance.emit(CHAT_EVENT_MOUSE_MOVE_ON_WIDGET_INNER_ROOT);
}

let currentTab = WidgetStore.currentTab;

let currentTabIsChat = computed(() => {
    return currentTab.value.type == TAB_TYPE_CHAT;
});

let isTransitionAllowed = ref<boolean>(false);

async function changeTransitionAllowed() {
    let value = WidgetStore.isOpened.value;
    try {
        await Delay.make(value ? 1000 : 1, 'changeTransitionAllowed', true);
        isTransitionAllowed.value = WidgetStore.isOpened.value;
    } catch (e) {
    }
}

watch(() => WidgetStore.isOpened.value, changeTransitionAllowed);
changeTransitionAllowed();



let rootId = WidgetStore.widgetInnerContainerId;

return (_ctx: any,_cache: any) => {
  return (_unref(currentTab))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "widget-root d-flex vertical",
        ref: "root",
        id: _unref(rootId),
        onMousemove: onMouseMove,
        onTouchstart: onMouseMove
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(ConfigStore).isEmptyWidget.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(ChatTab),
                _createVNode(_Transition, {
                  name: _unref(isTransitionAllowed) ? 'tab' : 'none',
                  mode: "in-out"
                }, {
                  default: _withCtx(() => [
                    (!_unref(currentTabIsChat))
                      ? (_openBlock(), _createBlock(ContentTab, {
                          key: _unref(currentTab).id,
                          tab: _unref(currentTab)
                        }, null, 8, ["tab"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["name"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(WidgetWebRtcCallOverlay)
        ]),
        _createVNode(SideMenu),
        _createVNode(ReviewForm),
        _createVNode(ExportChatForm),
        _createVNode(ClientCaptcha),
        _createVNode(ChatRootModalMessage, { "for-body": false })
      ], 40, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})